/**
 *
 * FlashCardLanding
 *
 */

import { mapState, mapGetters } from 'vuex';

//import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import FlashCardBook from '@/views/FlashCard/FlashCardLanding/components/FlashCardBook.vue';
import FlashCardFavorite from '@/views/FlashCard/FlashCardLanding/components/FlashCardFavorite.vue';
import { GetCourseFlashCardListMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/GetCourseFlashCardListMixin';
import { DASHBOARD_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from './FlashCardLanding.constants';

export default {
  name: 'FlashCardLanding',

  mixins: [GetCourseFlashCardListMixin],

  components: {
    //WayFindBar,
    ToolBar,
    Footer,
    Spinner,
    FlashCardBook,
    FlashCardFavorite,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('FlashCard/FlashCardLanding', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('FlashCard/FlashCardLanding', {
      mg_flashCardList: 'flashCardList',
    }),
  },

  methods: {
    goBack() {
      this.$router.push(DASHBOARD_PAGE);
    },
  },
};
